'use client';

import cn from 'classnames';
import moment from 'moment';
import type { ReactNode } from 'react';
import { useToggle } from 'react-use';
import { Collapse } from 'transitions-kit';

import { getENV, useSitePreviewData } from '@libs/common-next';

import { dateToAz } from '../preview/configuration/date-picker/utils';
import css from './fold.module.scss';

type Props = {
    children: ReactNode;
};

export function Fold({ children }: Props) {
    const [open, toggle] = useToggle(false);
    const previewData = useSitePreviewData();
    const previewMode = previewData?.contentfulPreviewMode ?? false;
    const ephemeral = getENV('NEXT_PUBLIC_EPHEMERAL');
    const formattedDate = previewData
        ? moment(dateToAz(previewData.previewDate ?? new Date().toISOString())).format('MMM D, HH:mm')
        : null;

    return (
        <div className={cn('devtools', css.devtool)}>
            <div className={css.surface}>
                <Collapse in={open} mountOnEnter unmountOnExit>
                    <div className={css.content}>{children}</div>
                </Collapse>
                <button
                    type="button"
                    className={cn(css.icon, { [css.open]: open, [css.pill]: !!formattedDate })}
                    onClick={toggle}
                >
                    <span className={css.gear}>⚙︎</span>
                    {ephemeral && <span className={css.env}>{ephemeral}</span>}
                    {formattedDate && (
                        <span className={css.previewInfo}>
                            <span className={css.date}>{formattedDate}</span>
                            <span className={previewMode ? css.draft : css.published}>
                                <span className={css.dot} />
                                {previewMode ? 'Preview' : 'Delivery'}
                            </span>
                        </span>
                    )}
                </button>
            </div>
        </div>
    );
}
